<template>
  <div style="width: 100%" v-show="showAllDevices === 3 && !showCritical">
    <div style="width: 100%" v-if="filteredAllDevices">
      <vue-good-table
        class="table"
        :columns="fields_"
        :rows="filteredAllDevices"
        :line-numbers="true"
        mode="remote"
        :sort-options="{
          enabled: true,
        }"
        :pagination-options="{ enabled: true }"
        @on-page-change="onPageChange"
        @on-per-page-change="onPageChange"
        @on-row-click="tableRowClicked"
        @on-sort-change="onSortChange"
      >
        <template slot="table-row" slot-scope="props" style="background: red">
          <span v-if="props.column.field == 'status'">
            <div
              :key="`${props.row.TimeStamp}_${props.row.InverterId}`"
              class="table_status"
              :class="{
                'badge-danger': statusCalc(props.row.TimeStamp),
                'badge-success': !statusCalc(props.row.TimeStamp),
              }"
            ></div>
            <!-- <status :timestamp="props.row.TimeStamp"></!-->
          </span>
          <span v-else-if="props.column.field == 'ownerName'">
            <p>{{ props.row.ownerName }}</p>
            <!-- <p>{{ props.row.InverterId }}</p> -->
          </span>
          <span v-else-if="props.column.field == 'deviceType'">{{
            props.row.deviceType
          }}</span>
          <span v-else-if="props.column.field == 'version'">{{
            `${props.row.version} / ${props.row.FV}`
          }}</span>
          <span v-else-if="props.column.field == 'panelpower'">{{
            props.row.panelpower
          }}</span>
          <!-- <span v-else-if="props.column.field == 'InverterId'">{{
            props.row.InverterId
          }}</span> -->
          <span v-else-if="props.column.field == 'OutputLoadPercent'"
            >{{
              `${props.row.contractualLoad} / ${props.row.OutputLoadPercent}`
            }}%</span
          >
          <span v-else-if="props.column.field == 'installedCapacity'">{{
            `${props.row.installedPV} / ${props.row.installedCapacity}`
          }}</span>
          <!-- <span
            v-else-if="props.column.field == 'installedCapacity'"
          >{{ props.row.installedCapacity }}kVA</span> -->
          <span
            v-else-if="props.column.field == 'batteryMode'"
            style="display: flex; flex-flow: row"
            >{{ props.row.batteryMode }}</span
          >

          <span
            v-else-if="props.column.field == 'BatteryCapacity'"
            style="display: flex; flex-flow: row"
          >
            <battery
              :mini="true"
              :width="`18px`"
              :height="`10px`"
              :direction="`y`"
              style="margin-top: 5px"
              :level="props.row.BatteryCapacity"
            ></battery>

            <span>{{ `${props.row.BatteryCapacity * 1}%` }}</span>
          </span>

          <span v-else-if="props.column.field == 'Time'">{{
            `${formatDate(props.row.Time)}`
          }}</span>

          <span v-else>{{ props.row[props.column.field] }}</span>
        </template>


        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :currentPage="tableOptions.currentPage"
            :total="pagination.totalRecords"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            @paginated-info="showPaginatedInfo($event)"
            :perPage="pagination.limit"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
    <div
      style="
        display: flex;
        flex-flow: column;
        min-height: 500px;
        justify-content: center;
        align-items: center;
      "
      v-else-if="!filteredAllDevices && !showCritical"
    >
      <span
        class="fa fa-spinner fa-4x animated rotateIn infinite loadingState"
        style="color: #1a93ca"
      ></span>
      <h3>Wait a second..</h3>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import Battery from "../../kitchen/grey-battery";
import Status from "../../kitchen/status-indicator";
let items = [];
export default {
  name: "AllDevices",
  props: {
    showAllDevices: {
      type: Number,
      default: null,
    },
    tableRowClicked: { type: Function },
    formatDate: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    total: { type: Number },
    activeTab: { type: Boolean },
    showCritical: { type: Boolean },
    filteredAllDevices: { type: Array, default: [] },
  },
  components: {
    Battery,
    Status,
  },
  computed: {
    ...mapGetters(["graphDeviceDetails", "getGlobalTableOptions", "devicePayload"]),
    tableOptions: {
      get() {
        return this.getGlobalTableOptions.performance;
      },
    },
    pagination: {
      get(){
        return this.devicePayload
      }
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      allDevices: [],
    };
  },
  methods: {
    ...mapActions(["setGlobalTableOptions"]),
    showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    emitChange(){
      this.$emit("getDevicesData")
    },
    onSortChange(params){
      this.$emit("sortData", params)
    },
    statusCalc(date) {
      var difference = Math.abs(moment(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange(params) {
      let tmpState = {
        ...this.getGlobalTableOptions,
        performance: { ...params },
      };
      if (this.activeTab === true) {
        // console.log("All"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }

      this.emitChange();

      // console.log(params.currentPerPage, "()()")
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    },
  },
  mounted() {
    // $forceUpdate();
    // window.location.reload();
    // console.log({ filteredAllDevices: this.filteredAllDevices });
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/performance/widgets/allDevices2.vue